import { RootState } from 'app/store';
import Button from 'common/components/buttons/button';
import { FC, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  selectMapStateByComponentId,
  setInitialMapState,
  zoomIn,
  zoomOut
} from './googleStaticMapSlice';
import { ButtonTheme } from 'common/components/buttons/button-theme';

export interface Location {
  city: string;
  regionName: string;
  country: string;
}

export const GoogleStaticMap: FC<{
  componentId: string;
  mapHeight: number;
  mapWidth: number;
  locations: Location[];
}> = ({ componentId, mapHeight, mapWidth, locations }) => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(
      setInitialMapState({
        componentId,
        initialFocusLocation: `${locations[0].city}, ${locations[0].regionName}, ${locations[0].country}`,
        initialZoomLevel: 10
      })
    );
  }, []);

  const { isInGlobalFocusMode, currentFocusLocation, currentZoomLevel } =
    useSelector((state: RootState) =>
      selectMapStateByComponentId(state, componentId)
    );

  const createMapUrl = (): string => {
    if (isInGlobalFocusMode && locations.length > 1) {
      return `https://maps.googleapis.com/maps/api/staticmap?key=${
        process.env.REACT_APP_GOOGLE_API_KEY
      }&size=${mapWidth}x${mapHeight}&markers=${locations
        .map(
          (location) =>
            `${location.city}, ${location.regionName}, ${location.country}`
        )
        .join('%7C')}`;
    } else {
      return `https://maps.googleapis.com/maps/api/staticmap?key=${process.env.REACT_APP_GOOGLE_API_KEY}&size=${mapWidth}x${mapHeight}&markers=${currentFocusLocation}&zoom=${currentZoomLevel}`;
    }
  };
  return (
    <>
      <div className="relative">
        <div className="absolute bottom-12 right-2">
          <Button
            onClick={() => dispatch(zoomIn(componentId))}
            identifier="zoom-in"
            theme={ButtonTheme.MAPZOOM}
            classOverrides=" text-center align-middle w-7 h-7"
          >
            <span>+</span>
          </Button>
        </div>

        <div className="absolute bottom-5 right-2">
          <Button
            onClick={() => dispatch(zoomOut(componentId))}
            identifier="zoom-out"
            theme={ButtonTheme.MAPZOOM}
            classOverrides="absolute text-center align-middle w-7 h-7"
          >
            <span>-</span>
          </Button>
        </div>

        <div className="absolute top-2 right-2">
          <Button
            onClick={() =>
              dispatch(
                setInitialMapState({
                  componentId,
                  initialFocusLocation: `${locations[0].city}, ${locations[0].regionName}, ${locations[0].country}`,
                  initialZoomLevel: 10
                })
              )
            }
            identifier="reset"
            theme={ButtonTheme.MAPRESET}
            classOverrides="text-center align-middle w-10 h-7"
          >
            <span>Reset</span>
          </Button>
        </div>

        <p
          className="absolute top-0 left-0 w-full h-full rounded-t bg-cover z-10"
          style={{ backgroundImage: 'url("/media/misc/europe.png")' }}
        ></p>
        <img
          className="h-60 rounded-t relative z-20"
          src={createMapUrl()}
        ></img>
      </div>
    </>
  );
};
